module.exports = __webpack_public_path__ + "media/images/aloe/icons/demo/elements/inputs-b474d1580637dcba0f1e802f5c16918a.svg";